import { AnimatePresence, motion } from "framer-motion";
import { MailCheck } from "lucide-react"; 

export default function ModalLoginSuccess({ successEmail, setSuccesEmail }) {
  return (
    <AnimatePresence>
      {successEmail && (
        <motion.div
          key="modal-background"
          onClick={() => setSuccesEmail(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full mx-4 text-center"
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -50, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            onClick={(e) => e.stopPropagation()} 
          >
            <MailCheck className="w-12 h-12 text-green-500 mx-auto mb-4" /> 
            <h2 className="text-xl font-semibold mb-2">Correo enviado</h2>
            <p className="text-gray-600">
              Listo, se ha enviado un correo a tu cuenta para poder restablecer tu contraseña.
            </p>
            <button
              onClick={() => setSuccesEmail(false)}
              className="mt-4 bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition-colors"
            >
              Cerrar
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}